import React from 'react';
import './VisitStoreBanner.css';

const VisitStoreBanner = () => {
  return (
    <section className="visit-store-section reveal-el">
      <div className="visit-store-container container">
        <div className="visit-store-content">
          <span className="visit-store-badge">PALLYWEAR FLAGSHIP</span>
          <h2 className="visit-store-title">Visit Us at Pallywear</h2>
          <p className="visit-store-desc">
            Step into the world of premium fashion. Experience the quality of our signature heavyweight tees, classic polos, and graphic hoodies in person. Feel the luxury fabrics, explore exclusive in-store designs, and find your perfect drape.
          </p>
          <div className="visit-store-details">
            <div className="detail-item">
              <span className="detail-icon">📍</span>
              <div className="detail-text">
                <h4>Our Locations</h4>
                <div className="location-list">
                  <div className="location-branch">
                    <strong className="branch-name">Chennai Store:</strong>
                    <p className="branch-address">No. 4, 244, Muthamil Nagar, Shanthi Nagar, Saravana Bawa Nagar, Old Perungalathur, Chennai, Tamil Nadu 600063</p>
                  </div>
                  <div className="location-branch" style={{ marginTop: '0.75rem' }}>
                    <strong className="branch-name">Bengaluru Store:</strong>
                    <p className="branch-address">Shop No.2, Ground Floor, Sri Vishnu Nilayam, No.29, 13th Main Road, Nisarga colony, Horamavu, Bengaluru, Karnataka 560043</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="detail-item">
              <span className="detail-icon">📞</span>
              <div className="detail-text">
                <h4>Phone / Contact</h4>
                <p>095975 28585 / 099440 65127</p>
              </div>
            </div>
            <div className="detail-item">
              <span className="detail-icon">🕒</span>
              <div className="detail-text">
                <h4>Store Hours</h4>
                <p>Mon - Sat: 9:00 AM - 7:00 PM (Sunday Closed)</p>
              </div>
            </div>
          </div>
          <a
            href="https://maps.google.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary visit-store-btn"
          >
            Get Store Directions
          </a>
        </div>

        {/* Image */}
        <div className="visit-store-image-wrapper">
          <img
            src="/images/store-design.webp"
            alt="Pallywear Flagship Store - Personalized Merchandise, Embroidery & Apparel"
            className="visit-store-image"
            loading="lazy"
            decoding="async"
            width="600"
            height="450"
            onError={(e) => { e.currentTarget.src = '/images/pallywear-storefront.webp'; }}
          />
        </div>
      </div>
    </section>
  );
};

export default VisitStoreBanner;
